import React, { Component } from 'react';
import { Form } from 'antd';
import { connect } from 'react-redux';
import { contractSettingsActions } from '../redux/actions';

// компоненты контейнера
import Section1 from '../../components/contractSettings/formSections/section_1';
import Section2 from '../../components/contractSettings/formSections/section_2';
import Section3 from '../../components/contractSettings/formSections/section_3';
import Section4 from '../../components/contractSettings/formSections/section_4';
import Section5 from '../../components/contractSettings/formSections/section_5';
import Section6 from '../../components/contractSettings/formSections/section_6';

// настройки договора фоотер
import ContractSettingsFooter from '../../components/contractSettings/Footer/Footer';
// выдвигалка из настройки столбцов

// Футтер !
import Footer from '../../../../common/hoc/withFooter';
// поля по умолчанию
import defaultFields from './defaultSettings';
// стили
import './ContractSettings.css';

//Actions
// interface for form
const { setContractField, resetDefaultValues } = contractSettingsActions;

class ContractSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabledFields: true,
    };
    this.disabledFieldsSetter = this.disabledFieldsSetter.bind(this);
    this.resetDefaultValues = this.resetDefaultValues.bind(this);
  }

  componentDidUpdate() {
    console.log(this.state);
  }

  disabledFieldsSetter() {
    this.setState((state, props) => ({
      disabledFields: !state.disabledFields,
    }));
  }
  resetDefaultValues() {
    const { setFieldsValue } = this.props.form;
    for (let [name, value] of Object.entries(defaultFields)) {
      setFieldsValue({ [name]: value });
    }
  }

  render() {
    const { fields, form } = this.props;
    const { disabledFields } = this.state;
    return (
      <div>
        <Form className="contractSettingsForm">
          <Section1
            form={form}
            fields={fields}
            disabledFields={disabledFields}
          />
          <Section2
            form={form}
            fields={fields}
            disabledFields={disabledFields}
          />
          <Section3
            form={form}
            fields={fields}
            disabledFields={disabledFields}
          />
          <Section4
            form={form}
            fields={fields}
            disabledFields={disabledFields}
          />
          <Section5
            form={form}
            fields={fields}
            disabledFields={disabledFields}
          />
          <Section6
            form={form}
            fields={fields}
            disabledFields={disabledFields}
          />
        </Form>

        <Footer>
          <ContractSettingsFooter
            resetDefaultValues={this.resetDefaultValues}
            disabledFieldsSetter={this.disabledFieldsSetter}
          />
        </Footer>
      </div>
    );
  }
}

export default connect(
  state => ({
    // CRUD data
    //FORM DATA
    fields: state.Documents.contractSettings,
  }),
  {
    // CRUD METHODS
    //FORM ACTIONS
    setContractField,
    resetDefaultValues,
  }
)(
  Form.create({
    name: 'contractSettingsForm',
    onValuesChange: ({ setContractField }, fieldObj) => {
      setContractField(fieldObj);
    },
  })(ContractSettings)
);
